import React from "react";
import SpecialtyConsole from "./SpecialtyConsole";

const CALCULATORS = [
  {
    name: "qSOFA (Sepsis-3)",
    endpoint: "qsofa",
    fields: [
      { name: "altered_mental_status", label: "Altered mentation", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "systolic_bp", label: "Systolic BP (mmHg)" },
      { name: "respiratory_rate", label: "Respiratory rate" },
    ],
    defaults: { altered_mental_status: false, systolic_bp: 110, respiratory_rate: 18 },
  },
  {
    name: "SIRS",
    endpoint: "sirs",
    fields: [
      { name: "temp_c",  label: "Temp (°C)" },
      { name: "hr",      label: "Heart rate" },
      { name: "rr",      label: "Respiratory rate" },
      { name: "wbc_10_3", label: "WBC (10³/µL)" },
    ],
    defaults: { temp_c: 38.4, hr: 105, rr: 22, wbc_10_3: 13.5 },
  },
  {
    name: "CURB-65 (Pneumonia severity)",
    endpoint: "curb65",
    fields: [
      { name: "confusion",    label: "Confusion", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "urea_mg_dl",   label: "Urea (mg/dL)" },
      { name: "respiratory_rate", label: "Resp. rate" },
      { name: "systolic_bp",  label: "Systolic BP" },
      { name: "diastolic_bp", label: "Diastolic BP" },
      { name: "age",          label: "Age" },
    ],
    defaults: { confusion: false, urea_mg_dl: 21, respiratory_rate: 22,
                systolic_bp: 105, diastolic_bp: 65, age: 72 },
  },
  {
    name: "NEWS2",
    endpoint: "news2",
    fields: [
      { name: "respiratory_rate", label: "Resp. rate" },
      { name: "spo2",             label: "SpO2 %" },
      { name: "on_oxygen",        label: "On supplemental O2?", type: "select",
        options: [{value: false, label: "No"}, {value: true, label: "Yes"}] },
      { name: "temp_c",           label: "Temp (°C)" },
      { name: "systolic_bp",      label: "SBP" },
      { name: "hr",               label: "HR" },
      { name: "consciousness_acvpu", label: "ACVPU", type: "select",
        options: [{value: "A", label: "Alert"}, {value: "C", label: "Confused"},
                  {value: "V", label: "Verbal"}, {value: "P", label: "Pain"},
                  {value: "U", label: "Unresponsive"}] },
    ],
    defaults: { respiratory_rate: 22, spo2: 93, on_oxygen: false, temp_c: 38.6,
                systolic_bp: 105, hr: 108, consciousness_acvpu: "A" },
  },
];

export default function InfectiousDisease() {
  return <SpecialtyConsole
    specialtyId="infectious_disease"
    title="Infectious Disease"
    tagline="Sepsis, CAP, and stewardship"
    accent="#22C55E"
    calculators={CALCULATORS}
  />;
}
